var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-group" }, [
    _c(
      "div",
      {
        staticClass: "custom-align-item",
        class: { active: _vm.value === "left", dark: _vm.theme === "dark" },
        on: {
          click: function ($event) {
            return _vm.chooseAlign("left")
          },
        },
      },
      [_c("i", { class: _vm.alignLeftIcon })]
    ),
    !_vm.disableCenter
      ? _c(
          "div",
          {
            staticClass: "custom-align-item",
            class: {
              active: _vm.value === "center",
              dark: _vm.theme === "dark",
            },
            on: {
              click: function ($event) {
                return _vm.chooseAlign("center")
              },
            },
          },
          [_c("i", { class: _vm.alignCenterIcon })]
        )
      : _vm._e(),
    _c(
      "div",
      {
        staticClass: "custom-align-item",
        class: { active: _vm.value === "right", dark: _vm.theme === "dark" },
        on: {
          click: function ($event) {
            return _vm.chooseAlign("right")
          },
        },
      },
      [_c("i", { class: _vm.alignRightIcon })]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }